/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs */

const es_marketplace_seo_galicia_guide_salvora_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excursión en barco a Isla Sálvora`)
};

const gl_marketplace_seo_galicia_guide_salvora_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excursión en barco á Illa Sálvora`)
};

const en_marketplace_seo_galicia_guide_salvora_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat trip to Sálvora island`)
};

/**
* | output |
* | --- |
* | "Boat trip to Sálvora island" |
*
* @param {Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_salvora_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Salvora_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_salvora_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_salvora_title(inputs)
	return es_marketplace_seo_galicia_guide_salvora_title(inputs)
});